/**
 * Builds the URLs for the group endpoints on the permission API
 * (`BD_PERMISSION_RESOURCE_URL`). Shared by both {@link BdPermissionsGroupsService}
 * and {@link BdPermissionsGroupsAdminService} — the endpoints are identical
 * regardless of the caller, so there is a single store to maintain.
 *
 * Every path keeps its trailing slash: the backend maps the routes as
 * `/groups/{id}/` and runs on Spring Boot 4, where trailing-slash matching is
 * disabled — a slash-less URL misses the route and returns 404.
 */
export class BdPermissionsGroupsStore {
  constructor(private readonly _baseUrl: string) {}

  public base(): string {
    return this._baseUrl;
  }

  public index(): string {
    return `${this.base()}/groups/`;
  }

  public getById(groupId: string): string {
    return `${this.base()}/groups/${groupId}/`;
  }

  public members(groupId: string): string {
    return `${this.getById(groupId)}members/`;
  }
}
